import * as React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import { KV } from 'models/IfKV';

type Props = {
  kv: KV<string, string>;
  onClick: (tag: string) => void;
  sel: boolean;
};
export const ListItem = ({ kv, onClick, sel }: Props) => {
  return (
    <Body onClick={() => onClick(kv.key)} className={clsx({ sel })}>
      {kv.val}
    </Body>
  );
};

const Body = styled.div`
  cursor: pointer;
  display: inline-block;
  padding: 0.8rem;
  margin: 0.2rem;
  border-radius: 0.4rem;
  //border: 1px solid #ccc;
  background-color: white;

  &.sel {
    background-color: #2e408e;
    color: white;
  }

  &:hover {
    background-color: #e5e5e5;
  }
`;
